import { useContext, useCallback } from 'react';
import { TranslationContext } from '../contexts/translation';
import { setTranslationValues } from '../core/helpers/setTranslationValues';

const useTranslation = () => {
  const translations = useContext(TranslationContext);
  return useCallback(
    (key, objWithTranslationValues = {}) => {
      if (Object.keys(translations).length) {
        let translatedText = translations[key] ? translations[key] : key;

        if (objWithTranslationValues && Object.keys(objWithTranslationValues).length) {
          translatedText = setTranslationValues(translatedText, objWithTranslationValues);
        }

        return translatedText;
      }
      return key
        .toLowerCase()
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
    [translations]
  );
};

export default useTranslation;
